import css from '../tpl-css/style-section-marquee-kyroro.js';
const html = `
<style>${css}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
    data-top-padding="true" data-bottom-padding="true" data-color="#ffffff"
    style="background-color: #ffffff; color: #ffffff; --text-color: #ffffff;">
    <div class="container-markqueue" data-attribute="container-markqueue" data-background-markqueue="#ffffff"
        style="background-color: rgb(255, 255, 255); --background-color-markqueue: #ffffff;">
        <div data-attribute="block-markqueue" class="block-markqueue">
            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e21c8b26940fea494ae6.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e21ff6b8bb5151c1c531.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e22532ca44450352902d.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e22cfb10978d6523495a.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e230dca5fe506cad5dd3.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e233173df651770262e9.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e236923e1acce4568deb.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e239b0129959112d6259.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e23c55e2551be431f852.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e240ecb9679f407d3d75.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>

            <a href="#" target="_blank" data-attribute="item-markqueue" class="item-markqueue">
                <div class="icon-item">
                    <img data-attribute="icon-item-markqueue"
                        src="https://cdn.skyfastimg.com/6840597d19b44700093c96f9/2026/05/12/image-6a02e2472b5f2afff2816ff7.png"
                        alt="" />
                </div>
                <div data-attribute="text-item-markqueue" class="text-item"></div>
            </a>
        </div>
    </div>
</div>
`;
export default html;
